import { createContext, useContext } from "react";

interface OnboardingGuideContextValue {
  enableSkipButton: boolean;
}

export const OnboardingGuideContext =
  createContext<OnboardingGuideContextValue>({ enableSkipButton: false });

export const useOnboardingGuideContext = () =>
  useContext(OnboardingGuideContext);
